export default {
  title: 'Definições de gorjeta',
  form: {
    has_tips: {
      label: 'Permitir gorjetas',
    },
    default_tip_percentage: {
      label: 'Taxa de gorjeta pré-selecionada',
      tooltip: 'Esta é a taxa que será pré-selecionada para o cliente quando chegar ao ecrã de pagamentos',
    },
    is_tip_hidden_on_receipt: {
      label: 'Gorjetas não visíveis nos recibos',
      tooltip: 'Quando ativado, oculta as gorjetas nos recibos impressos e na janela de informações da encomenda',
    },
  },
  buttons: {
    save: 'Guardar',
  },
  toasts: {
    failed_to_save_changes: 'Falha ao guardar alterações',
    changes_got_saved: 'Alterações guardadas',
  },
};
